import { Facility } from '@reliance/types/models/Facility';
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import api from '../common/api';
import { useAlerts } from '../alert/AlertContext';

type MigrateItdsModalProps = {
  show: boolean;
  facility: Facility;
  onClose(migrated?: boolean): void;
};

const MigrateItdsModal: React.FC<MigrateItdsModalProps> = (props) => {
  const [migrating, setMigrating] = useState(false);
  const alerts = useAlerts();

  const migrate = () => {
    setMigrating(true);

    api.post(`/itds/migrate-facility/${props.facility.id}`).then(() => {
      setMigrating(false);
      alerts.success('The facility was successfully migrated');
      props.onClose(true);
    });
  };

  return (
    <Modal show={props.show} onHide={props.onClose}>
      <Modal.Body>
        This will migrate all inmates at the facility from the legacy ITDS accounts to the wallet-integrated system.
        <br/><br/>
        This operation cannot be undone. Only proceed when the jail is ready to migrate.
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => props.onClose(false)} disabled={migrating}>
          Cancel
        </Button>
        <Button variant="primary" type="button" onClick={migrate} disabled={migrating}>
          {migrating ? 'Migrating...' : 'Migrate'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MigrateItdsModal;
